import { qaLabelDispatch } from '../../../../../common-qa-labels/dispatch';
import { LineItem } from '@vromo/models';
import FontAwesome from '@vromo/ui/components/FontAwesome';
import Input from '@vromo/ui/components/Input';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './lineItem.style';
import { observer } from 'mobx-react-lite';

interface Props {
    item: LineItem;
    onDescriptionChange: JSX.IntrinsicElements['input']['onChange'];
    onQuantityChange: JSX.IntrinsicElements['input']['onChange'];
    onRemove: () => void;
}

const LineItemComponent = observer(({ item, onDescriptionChange, onQuantityChange, onRemove }: Props) => {
    const { t } = useTranslation();

    return (
        <tr key={item.id}>
            <td style={styles.itemDescription}>
                <Input
                    data-testid={qaLabelDispatch.newJobModal.itemsInput}
                    required
                    type="text"
                    value={item.title}
                    placeholder={t('common.description')}
                    onChange={onDescriptionChange}
                />
            </td>
            <td style={styles.itemQuantity}>
                <Input
                    required
                    type="number"
                    value={item.quantity}
                    placeholder={t('lineItems.quantityShort')}
                    min={1}
                    onChange={onQuantityChange}
                />
            </td>
            <td style={styles.removeItem}>
                <a onClick={onRemove}>
                    <FontAwesome icon="minus-circle" large />
                </a>
            </td>
        </tr>
    );
});

export default LineItemComponent;
